/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Menueditormoveup3Inputs */

const en_menueditormoveup3 = /** @type {(inputs: Menueditormoveup3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} up`)
};

const de_menueditormoveup3 = /** @type {(inputs: Menueditormoveup3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach oben`)
};

/**
* | output |
* | --- |
* | "Move {name} up" |
*
* @param {Menueditormoveup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditormoveup3 = /** @type {((inputs: Menueditormoveup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditormoveup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditormoveup3(inputs)
	return de_menueditormoveup3(inputs)
});
export { menueditormoveup3 as "menuEditorMoveUp" }